export interface ScriptLink {
  src: string;
  async: boolean;
  defer: boolean;
  id?: string;
  crossorigin?: string;
}

export interface ChatWidget {
  provider: string;
  config: Record<string, any>;
}

export interface BodyEndData {
  inlineScripts: string;
  scriptLinks: ScriptLink[];
  chatWidgets: ChatWidget[];
  noScriptContent: string;
}

export interface BodyEndEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: BodyEndData) => void;
  initialData?: Partial<BodyEndData>;
  isLoading?: boolean;
}

export const INITIAL_BODY_END_DATA: BodyEndData = {
  inlineScripts: '',
  scriptLinks: [],
  chatWidgets: [],
  noScriptContent: '',
};

export type TabType = 'inline' | 'external' | 'chat' | 'noscript';

export interface Tab {
  id: TabType;
  label: string;
  icon: 'code' | 'external' | 'chat' | 'info';
}

export const TABS: Tab[] = [
  { id: 'inline', label: 'Inline Scripts', icon: 'code' },
  { id: 'external', label: 'External Scripts', icon: 'external' },
  { id: 'chat', label: 'Chat Widgets', icon: 'chat' },
  { id: 'noscript', label: 'NoScript', icon: 'info' },
];
